import { getApiErrorMessage } from '@/shared/api/apiError';
import { cn } from '@/shared/lib/utils';
import { Spinner } from './Spinner';

interface ListStateProps {
  isLoading: boolean;
  error: unknown;
  isEmpty: boolean;
  emptyMessage?: string;
}

/** 카드 목록의 로딩·에러·빈 상태. 표시할 상태가 없으면 아무것도 그리지 않는다 */
export function ListState({
  isLoading,
  error,
  isEmpty,
  emptyMessage = '조회 결과가 없어요.',
}: ListStateProps) {
  if (isLoading) {
    return (
      <div
        role="status"
        className="flex w-full flex-col items-center gap-3 rounded-20 bg-surface-white py-16 text-body-14 font-medium text-fg-light"
      >
        <Spinner size="lg" />
        불러오는 중…
      </div>
    );
  }

  let message: string | null = null;
  if (error) message = getApiErrorMessage(error, '목록을 불러오지 못했어요.');
  else if (isEmpty) message = emptyMessage;
  if (!message) return null;

  return (
    <div
      className={cn(
        'w-full rounded-20 bg-surface-white py-16 text-center text-body-14 font-medium',
        error ? 'text-fg-error' : 'text-fg-light',
      )}
    >
      {message}
    </div>
  );
}
